/*
 * 发布管理接口
 * */
import services from "../config/axios";
import base from "./base";

const newPublishManageAPI = {
    // 获取发布列表
    getPublishList<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetPublishList`, params);
    },
    // 获取数字员工档案
    getDigitalEmpList<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetDigitalEmpList`, params);
    },
    // 获取人才档案
    getTalentProfileList<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetTalentProfileList`,
            params
        );
    },
    // 新增发布申请
    addPublish<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/AddPublish`, params);
    },
    // 删除发布申请
    delPublish<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/DelPublish`, params);
    },
    // 更新发布申请
    updatePublish<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/UpdatePublish`, params);
    },
    // 管理员更新发布申请
    updateAdminPublish<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/UpdateAdminPublish`,
            params
        );
    },
    // 更新发布申请
    getPublishOne<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetPublishOne`, params);
    },

    // 提交发布
    submitPublish<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/SubmitPublish`, params);
    },
    //退休申请
    submitPublishRetire<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/SubmitPublishRetire`,
            params
        );
    },
    //添加使用人申请
    submitPublishAddMan<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/SubmitPublishAddMan`,
            params
        );
    },
    // 查询添加流程使用人申请历史
    getProcessAddManList<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetProcessAddManList`,
            params
        );
    },

    // 审批发布申请
    auditPublish<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/AuditPublish`, params);
    },

    //查询更新包列表
    getPackageList<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetPackageList`, params);
    },
    //查询更新包数量
    getPackageUpdateCount<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetPackageUpdateCount`,
            params
        );
    },
    //查询dify校验次数
    getDifyCheckCount<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetDifyCheckCount`, params);
    },
    // 获取需求审核列表
    getAuditList<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetAuditList`, params);
    },
    //更新发布包
    updatePublishPackage<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/UpdatePublishPackage`,
            params
        );
    },
    //使用某版本
    updatePackageVersion<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/UpdatePackageVersion`,
            params
        );
    },
    // 新增包更新队列
    addPackageQueue<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/AddPackageQueue`, params);
    },
    //查询上岗申请有没有附件
    checkPublishHasFiles<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/CheckPublishHasFiles`,
            params
        );
    },
    //绑定咚咚AI助理
    bindDifyAIAssistant<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/BindDifyAIAssistant`,
            params
        );
    },
    //解绑咚咚AI助理
    unbindDifyAIAssistant<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/UnBindDifyAIAssistant`,
            params
        );
    },
    //下载dify yaml
    getDifyYAML<T>(params: FormData) {
        return services.post(`${base.lk}/NewPublish/GetDifyYAML`, params);
    },
    //获取Dify AI助理绑定清单
    getDifyAIAssistantList<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetDifyAIAssistantList`,
            params
        );
    },
    //获取发布上岗数量
    getUiPathPublishCount<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetUiPathPublishCount`,
            params
        );
    },
    //检查是否发布过
    checkIsPublishEver<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/CheckIsPublishEver`,
            params
        );
    },
    // 更新包备注
    updatePackageDescription<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/UpdatePackageDescription`,
            params
        );
    },
    // 新增发布信息变更
    addPublishInfoChange<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/AddPublishInfoChange`,
            params
        );
    },
    // 获取信息变更历史
    getPublishInfoChange<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetPublishInfoChange`,
            params
        );
    },
    // 获取信息变更one
    getPublishInfoChangeOne<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetPublishInfoChangeOne`,
            params
        );
    },
    // 审批信息变更
    auditPublishInfoChange<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/AuditPublishInfoChange`,
            params
        );
    },
    //查询信息变更限制次数
    getPublishChangeCount<T>(params: FormData) {
        return services.post(
            `${base.lk}/NewPublish/GetPublishChangeCount`,
            params
        );
    },
};

export default newPublishManageAPI;
